import React from 'react';
import PropTypes from 'prop-types';

import {
  EDUCATION_SCHOOL,
  EDUCATION_DEGREE,
  CURRENT,
  END_DATE,
  DESCRIPTION,
} from '@zr/utilities/profileFields';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import SchoolField from '@zr/components/Fields/Formik/SchoolField';
import DegreeField from '@zr/components/Fields/Formik/DegreeField';
import CurrentlyInProgressField from '@zr/components/Fields/Formik/CurrentlyInProgressField';
import DegreeEndYearField from '@zr/components/Fields/Formik/DegreeEndYearField';
import DescriptionField from '@zr/components/Fields/Formik/DescriptionField';

/**
 * MinimalEducationFields is like EducationFields, but without major or start year
 */
export function MinimalEducationFields({
  formikProps, enableRichText,
}) {
  const { setValues, values } = formikProps;

  const handleCurrentChange = () => {
    // clear out end date values if current was changed
    // this also prevents submitting any previously filled values before changing current
    setValues({
      ...values,
      [END_DATE]: '',
    });
  };

  return (
    <>
      <SchoolField
        name={EDUCATION_SCHOOL}
        formikProps={formikProps}
      />
      <DegreeField
        name={EDUCATION_DEGREE}
        formikProps={formikProps}
      />
      <CurrentlyInProgressField
        name={CURRENT}
        onChange={handleCurrentChange}
        formikProps={formikProps}
      />
      {!values[CURRENT] && (
        <DegreeEndYearField
          name={END_DATE}
          formikProps={formikProps}
        />
      )}
      <DescriptionField
        name={DESCRIPTION}
        formikProps={formikProps}
        enableRichText={enableRichText}
      />
    </>
  );
}

MinimalEducationFields.propTypes = {
  formikProps: formikPropTypes.isRequired,
  enableRichText: PropTypes.bool,
};

MinimalEducationFields.defaultProps = {
  enableRichText: false,
};

export default MinimalEducationFields;
